import styled from '@emotion/styled';

export const BlueButton = styled.button`
  padding: 0 20px;
  background-color: var(--lp-colors-medium-blue-800);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-800);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 32px;

  &:disabled {
    opacity: 0.5;
  }
  &:first-of-type {
    margin-left: 0;
  }
`;

export const TurquoiseButton = styled.button`
  padding: 0 20px;
  background-color: var(--lp-colors-turquoise-600);
  color: #fff;
  border: 1px solid var(--lp-colors-turquoise-600);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 32px;

  &:disabled {
    opacity: 0.5;
  }
  &:first-of-type {
    margin-left: 0;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--lp-colors-medium-blue-600);
  font-size: 1.5rem;
  font-weight: 500;
  padding: 0;
  margin-left: auto;
`;

export const Heading = styled.h4`
  font-size: 1.25rem;
  font-weight: 500;
`;

export const Icon = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
`;
